export default __webpack_public_path__ + "static/media/Humidity.56262ed8.svg";